import { EventCallToAction } from 'globalTypes'

import { useMutation } from '@apollo/client'
import Button from 'Root/App/Button'
import mixpanelTrack from 'lib/mixpanel-track'

import MUTATION from './add-registration.graphql'

interface EventContentRegistration extends EventCallToAction {
  title: string
  slug: string
}

interface Props {
  content: EventContentRegistration
}

const AddRegistration = ({ content }: Props) => {
  const [mutate] = useMutation(MUTATION)

  const onClick = () => {
    mutate({
      variables: {
        id: content.id,
      },
    })

    mixpanelTrack("Registrato all'evento", {
      id_evento: content.slug,
      nome_evento: content.title,
    })
  }

  return <Button onClick={onClick}>Registrati all&apos;evento</Button>
}

export default AddRegistration
